import type { GraphQLClient, RequestOptions } from 'graphql-request';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Array: { input: any; output: any; }
  JsonArgument: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type RatingInput = {
  /** The rating (0 to 100) */
  rating?: InputMaybe<Scalars['Int']['input']>;
  /** The step id */
  step_uuid?: InputMaybe<Scalars['String']['input']>;
};

export type StudentInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationsAndGlobalsQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']['input']>;
}>;


export type NavigationsAndGlobalsQuery = { main?: { tree?: Array<{ page?: { id: string, title?: string | null, url?: string | null } | { id: string, title?: string | null, url?: string | null } | { id: string, title?: string | null, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | null } | null> | null } | null, footer?: { tree?: Array<{ page?: { id: string, title?: string | null, url?: string | null } | { id: string, title?: string | null, url?: string | null } | { id: string, title?: string | null, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | null } | null> | null } | null, administration?: { tree?: Array<{ page?: { id: string, title?: string | null, url?: string | null, access?: Array<string | null> | null } | {} | null } | null> | null } | null, general?: { schoolYearStartDate?: string | null } | null };


export const NavigationsAndGlobalsDocument = gql`
    query NavigationsAndGlobals($lang: String) {
  main: nav(handle: "main") {
    tree(site: $lang) {
      page {
        id
        title
        url
      }
    }
  }
  footer: nav(handle: "footer") {
    tree(site: $lang) {
      page {
        id
        title
        url
      }
    }
  }
  administration: nav(handle: "user_administration") {
    tree(site: $lang) {
      page {
        ... on NavBasicPage_UserAdministration {
          id
          title
          url
          access
        }
      }
    }
  }
  general: globalSet(handle: "general", site: $lang) {
    ... on GlobalSet_General {
      schoolYearStartDate
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    NavigationsAndGlobals(variables?: NavigationsAndGlobalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NavigationsAndGlobalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NavigationsAndGlobalsQuery>(NavigationsAndGlobalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NavigationsAndGlobals', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;